import React from "react"
import { Box } from "@rebass/grid/emotion"

import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"
import { ButtonWildMen } from "@nutrafol/nutrafol-ui-kit/dist/ButtonWildMen"

import { FlexContainer } from "./gwpatcarea.styled"

const TravelKitCard = ({ data }) => {
  const { heading, copy, containerClasses, image, button } = data

  return (
    <FlexContainer className={containerClasses || "justify-start"}>
      <Box className="img-box rounded-sm overflow-hidden">
        <img src={image} alt={``} role="presentation" />
      </Box>

      <Box>
        <TextElementMen
          element="h4"
          text={heading}
          className="body--regular-b text-master-secondary-default hide-lg-up"
        />
        <TextElementMen
          element="h4"
          text={heading}
          className="body--large-b text-master-secondary-default show-lg-up"
        />
        <TextElementMen
          text={copy}
          className="body--small text-master-base-alt-disabled"
        />
        {button ? (
          <ButtonWildMen textLink arrowRight label={button.label} />
        ) : null}
      </Box>
    </FlexContainer>
  )
}

export default TravelKitCard
